module.exports = __webpack_public_path__ + "img/xiangce.036edf03.png";